import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Divider, Text } from '@reveni-io/reveni-ui'

import AddConditionButtons from './AddConditionButtons/AddConditionButtons'
import ConditionsList from './ConditionsList/ConditionsList'
import { createCondition, getConditionTypeOptions } from './helpers'
import * as Styles from './styles'

const ConditionsEditor = ({
  conditions,
  onChange,
  disabled,
  errors = [],
  title,
  description,
  emptyMessage,
  conditionTypes,
  errorType,
  currencies,
  storeCurrencyCode,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleAddCondition = conditionTypeKey => {
    onChange({ conditions: [...conditions, createCondition(conditionTypes[conditionTypeKey])] })
  }

  const handleChangeCondition = (index, updatedCondition) => {
    const updatedConditions = conditions.map((c, i) => (i === index ? updatedCondition : c))
    onChange({ conditions: updatedConditions })
  }

  const handleRemoveCondition = index => {
    const updatedConditions = conditions.filter((_, i) => i !== index)
    onChange({ conditions: updatedConditions })
  }

  const conditionTypeOptions = getConditionTypeOptions(conditionTypes)

  return (
    <Styles.Container>
      <Text type="titleS">{t(title)}</Text>
      <Text type="bodyMRegular">{t(description)}</Text>
      {conditions.length === 0 && emptyMessage && (
        <Text type="bodyMRegular" color={theme.colors.text.subtle}>
          {t(emptyMessage)}
        </Text>
      )}
      <ConditionsList
        conditions={conditions}
        onChange={handleChangeCondition}
        onRemove={handleRemoveCondition}
        disabled={disabled}
        errors={errors}
        conditionTypes={conditionTypes}
        errorType={errorType}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
      />
      <Divider />
      <AddConditionButtons
        onAddCondition={handleAddCondition}
        disabled={disabled}
        conditionTypeOptions={conditionTypeOptions}
      />
    </Styles.Container>
  )
}

export default ConditionsEditor
